module.exports = __webpack_public_path__ + "img/title1.942202b9.png";